import * as React from 'react';

import { IBargainTerms } from '../../../types/results';
import { Text } from '../../Text';

export interface IBargainTermsInfoProps {
  bargainTerms: IBargainTerms;
  isNewbuilding: boolean;
}

export function BargainTermsInfo({ bargainTerms, isNewbuilding }: IBargainTermsInfoProps): JSX.Element {
  const { clientCommissionText, priceText, utilitiesText, depositText } = bargainTerms;

  if (isNewbuilding && priceText) {
    return (
      <div>
        <Text bold={true}>{priceText}</Text>
      </div>
    );
  }

  return (
    <>
      {priceText && (
        <div>
          <Text bold={true}>{priceText}</Text>
        </div>
      )}
      {depositText && (
        <div>
          <Text textSize="small" color="gray">
            {depositText}
          </Text>
        </div>
      )}
      {utilitiesText && (
        <div>
          <Text textSize="small" color="gray">
            {utilitiesText}
          </Text>
        </div>
      )}
      {clientCommissionText && (
        <div>
          <Text textSize="small" color="gray">
            {clientCommissionText}
          </Text>
        </div>
      )}
    </>
  );
}
